import { useSelector } from "react-redux";
import { getPersonalizedConfigOption } from "~/store/selectors/selector.configOptions";
import { userWorkGroupByDate } from "~/store/selectors/selector.userTasks";

export const useTeamByAssigneeTaskNavigation = (taskId, userId) => {
  let previous, next;
  const groupBy = useSelector((state) => getPersonalizedConfigOption(state, "team_tasks_group_by"));
  const collection = useSelector((state) => userWorkGroupByDate(state, groupBy, userId));
  const taskIdsFlat = Object.keys(collection)
    .map((key) => {
      return collection[key];
    })
    .flat()
    .map((item) => ({ task_id: item.taskId, assignee_id: item.assignee_id }));

  const taskIds = userId.reduce((acc, id) => {
    taskIdsFlat.forEach((t) => {
      if (t.assignee_id === id && !acc.includes(t.task_id)) {
        acc.push(t.task_id);
      }
    });
    return acc;
  }, []);

  const currentIndex = taskIds.indexOf(taskId);
  previous = currentIndex > -1 && taskIds[currentIndex - 1] ? taskIds[currentIndex - 1] : null;
  next = currentIndex > -1 && taskIds[currentIndex + 1] ? taskIds[currentIndex + 1] : null;

  return [previous, next];
};
